import { useTranslation } from "react-i18next"
import { Helmet } from "react-helmet"

export const PolicyComponent = () => {
  const { t } = useTranslation("Policy")

  return (
    <>
      <Helmet>
        <title>{t("Polityka prywatności w ALUPROFIL")}</title>

        <meta
          property="og:type"
          content="website"
        />
        
        <meta
          property="og:title"
          content={t("Polityka prywatności w ALUPROFIL")}
        />

        <script type="application/ld+json">
          {`{
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "${t("Polityka prywatności w ALUPROFIL")}"
          }`}
        </script>
      </Helmet>

      <div className="w-full bg-white">
        <div className="mx-auto container">
          <div className="flex flex-col px-4 py-16 place-items-center">
            <hr className="mb-16 w-full border-t-2 border-aluprofil-gray/20" />

            <h2 className="mb-16 w-full font-head font-normal text-5xl text-aluprofil-gray">
              {t("Polityka prywatności")}
            </h2>

            <div className="prose" dangerouslySetInnerHTML={{ __html: t("Polityka prywatności.Description") }} />
          </div>
        </div>
      </div>
    </>
  )
}
